import axios from "axios";
import { API } from "../../const";
import { normParam } from "../../tools";
const M_API = API;

const store = {
  namespaced: true,
  state: {
    jenis_kelas: null
  },
  getters: {
    jenis_kelas(state) {
      return state.jenis_kelas;
    }
  },
  mutations: {},
  actions: {
    // eslint-disable-next-line
    get({}, { instansi_id, params }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/m_jenis_kelas${normParam(params)}`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    form(_, { instansi_id, obj }) {
      if (obj.id) {
        return axios
          .put(`${M_API}/instansi/${instansi_id}/m_jenis_kelas/${obj.id}`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else {
        return axios
          .post(`${M_API}/instansi/${instansi_id}/m_jenis_kelas`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      }
    },
    // eslint-disable-next-line
    drop(_, item) {
      return axios.delete(`${M_API}/instansi/${item.instansi_id}/m_jenis_kelas/${item.id}`).then(res => {
        return res.data;
      });
    },
    // eslint-disable-next-line
    detail(_, { instansi_id, jenis_kelas_id }) {
      return (
        axios
          .get(`http://127.0.0.1:3000/kelola/instansi/${instansi_id}/jenis-kelas/${jenis_kelas_id}`)
          // .get(`${M_API}/instansi/${instansi_id}/m_jenis_kelas/${jenis_kelas_id}`)
          .then(res => {
            return res.data;
          })
          .catch(err => Promise.reject(err))
      );
    },
    // eslint-disable-next-line
    getSyarat() {
      return axios
        .get(`${M_API}/m_prasyarat`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    getValSyarat(_, { instansi_id, jenis_syarat }) {
      if (jenis_syarat.nama == "ketuntasan" || jenis_syarat.nama == "dependensi" || jenis_syarat.nama == "belum_daftar") {
        return axios
          .get(`${M_API}/m_jenis_kelas`)
          .then(res => {
            return res.data;
          })
          .catch(err => Promise.reject(err));
      } else {
        return axios
          .get(`${M_API}/instansi/${instansi_id}/prasyarat-list`)
          .then(res => {
            return res.data;
          })
          .catch(err => Promise.reject(err));
      }
    },
    // eslint-disable-next-line
    getSyaratApplied(_, { instansi_id, jenis_kelas_id }) {
      return axios
        .get(`${M_API}/instansi/${instansi_id}/m_jenis_kelas/${jenis_kelas_id}/prasyarat`)
        .then(res => {
          return res.data;
        })
        .catch(err => Promise.reject(err));
    },
    // eslint-disable-next-line
    setSyarat(_, { instansi_id, jenis_kelas_id, syarats, nama_syarat, syarat_url }) {

      if (syarats.data_syarat.length == 1) {
        let e = [];
        var data;
        if (syarat_url == "jenjang-dan-mapel") {
          syarat_url = syarat_url.slice(0, 7);
        }
        syarats["data_syarat"][0].data.forEach(element => {
          if (syarat_url == "pengguna") {
            data = {
              is_aktif: 1,
              jenis_pengguna: element.value
            };
          } else if (syarat_url == "jenjang") {
            data = {
              is_aktif: 1,
              jenjang_id: element.value
            };
          } else if (syarat_url == "ketuntasan" || syarat_url == "dependensi" || syarat_url == "belum-daftar") {
            data = {
              is_aktif: 1,
              syarat_jenis: element.id
            };
          } else {
            data = {
              is_aktif: 1,
              [nama_syarat]: element.value
            };
          }
          e.push(data);
        });
        return axios
          .post(`${M_API}/instansi/${instansi_id}/m_jenis_kelas/${jenis_kelas_id}/prasyarat-${syarat_url}`, e)
          .then(res => {
            return res;
          })
          .catch(e => e);
      } else if (syarats.data_syarat.length > 1) {
        var dt;
        var x = [];
        for (let i = 0; i < syarats.data_syarat.length; i++) {
          var ds = [];
          for (let j = 0; j < syarats.data_syarat[i].data.length; j++) {
            if (syarats.data_syarat[i].k_syarat.nama == "dependensi" || syarats.data_syarat[i].k_syarat.nama == "ketuntasan") {
              ds.push(syarats.data_syarat[i].data[j].id);
            } else {
              ds.push(syarats.data_syarat[i].data[j].value);
            }
          }
          dt = {
            k_syarat: syarats.data_syarat[i].k_syarat.id,
            data: ds
          };
          x.push(dt);
        }
        let obj = {
          is_aktif: 1,
          data_syarat: x
        };
        return axios
          .post(`${M_API}/instansi/${instansi_id}/m_jenis_kelas/${jenis_kelas_id}/prasyarat`, obj)
          .then(res => {
            return res;
          })
          .catch(e => e);
      }
    },
    dropSyarat(_, { instansi_id, item, syarat_url }) {
      if (syarat_url == "jenjang-dan-mapel") {
        syarat_url = syarat_url.slice(0, 7);
      }
      return axios
        .delete(`${M_API}/instansi/${instansi_id}/m_jenis_kelas/${item.k_jenis}/prasyarat-${syarat_url}/${item.hasil[0].k_syarat}`)
        .then(res => {
          return res;
        })
        .catch(e => e);
    }
    // eslint-disable-n
  }
};

export default store;
